export function LargeSubmit(props: any) {
  return (<div className="d-flex mt-2">
    <button className='btn btn-primary flex-grow-1' type='submit'>{props.text}</button>
  </div>);
}
